import React from 'react'
import DealingsNavigator from "../../components/DealingsNavigator";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";
import TenderCompletionDividedList from "./TenderCompletionDividedList";


function TenderCompletionDivided(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const curIndex = gVal("completionDealing", false, -1);

    return (<FieldArray
        name={gId("divided")}
        render={() => (<>
            <DealingsNavigator
                formikProps={formikProps}
                id="completionDealing"
                items={gVal("divided", true, [])}
            />
            {curIndex > -1 &&
                <TenderCompletionDividedList
                    formikProps={formikProps}
                    id={gId("divided." + curIndex)}
                    index={curIndex}
                />
            }

        </>)}
    />)
}

TenderCompletionDivided.propTypes = {};

export default TenderCompletionDivided;
